import MappingOriginOption from "~/models/mapping/mappingOriginOption";
import {ISSchema} from "~/interfaces/salesforceInterfaces";
import {IMappingOriginOptionSalesforce} from "~/interfaces/mappingInterfaces";
import {Logger} from "~/services/logger";

export default class MappingOriginOptionSalesforce extends MappingOriginOption<ISSchema> implements IMappingOriginOptionSalesforce {
  ORIGIN_TYPE: 'salesforce' = 'salesforce'
  type: 'single' | 'multi'
  sObjectSource: string

  constructor(opts: IMappingOriginOptionSalesforce) {
    super(opts)
    if (opts.type) {
      this.type = opts.type
    } else {
      Logger.errorOnce('MappingOriginOptionSalesforce', 'Type not provided. Please provide an type ("single" or "multi").')
    }
    if (opts.sObjectSource) {
      this.sObjectSource = opts.sObjectSource
    } else {
      Logger.errorOnce('MappingOriginOptionSalesforce', 'sObjectSource not provided.')
    }
  }

  get title(): string {
    return this.sObjectSource
  }

  get id(): string {
    return this.sObjectSource
  }
}